// Shared number formatting for figures the agent reads as data — vote counts,
// deltas, tallies. Deliberately not `getAmount`/`_handleTh` in helper.ts: those
// force two decimals for currency, which is wrong for a ballot count.

const nf = new Intl.NumberFormat();

/** Group-separated whole number. */
export const fmt = (n: number): string => nf.format(Math.round(Number.isFinite(n) ? n : 0));

/**
 * A delta with its sign always shown. Uses U+2212 MINUS SIGN, not a hyphen —
 * it aligns with digits in tabular-nums and reads as arithmetic, not as a dash.
 */
export const signed = (n: number): string => {
	const v = Number.isFinite(n) ? n : 0;
	return `${v > 0 ? '+' : v < 0 ? '−' : ''}${fmt(Math.abs(v))}`;
};
